import Analytics from '@/views/Analytics/Analytics.vue';
import AnalyticsComp from '@/components/Analytics/AnalyticsComp.vue';

export const analyticsRoutes = {
  path: 'analytics',
  name: 'analytics',
  component: Analytics,
  redirect: {
    name: 'analyticsPage',
  },
  children: [
    {
      name: 'analyticsPage',
      path: '',
      component: AnalyticsComp,
    },
  ],
};
